import { Link } from "react-router-dom";
import { UserCircle2, Handshake, Smartphone, ShieldCheck, KeyRound, Lock, Building2, ArrowRight, Shield } from "lucide-react";

const PORTALI = [
  [UserCircle2, "Area Riservata Cliente", ["Accesso con email e password o link magico", "Stato della pratica, diario e documenti condivisi", "Messaggi con lo studio e caricamento di foto e documenti", "Installabile come app con notifiche push"]],
  [Handshake, "Area Segnalatori", ["Accesso dedicato con codice via email", "Pratiche segnalate e relativo andamento", "Riepilogo delle spettanze maturate", "Installabile come app sullo smartphone"]],
  [Smartphone, "Pagina Foto mobile", ["Stesse credenziali del gestionale", "Ricerca rapida per cliente o targa", "Quattro pulsanti: veicolo, luogo, documenti, altro", "Foto archiviate subito nella pratica giusta"]],
];

const SICUREZZA = [
  [KeyRound, "Verifica in due passaggi", "Codice via email all'accesso e dispositivi attendibili."],
  [Lock, "Sessioni protette", "Una sessione attiva per utente, con avviso se l'accesso avviene altrove."],
  [Building2, "Dati separati per studio", "Ogni studio lavora nel proprio spazio, isolato dagli altri."],
  [ShieldCheck, "Link controllati", "Le condivisioni scadono, si revocano e lasciano traccia nel diario."],
];

export const LandingPortals = () => (
  <section id="portali" className="py-24 sm:py-32" data-testid="landing-portals">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <span className="text-xs font-mono uppercase tracking-wider text-amber-400">Aree riservate</span>
      <h2 className="mt-3 max-w-2xl font-head text-3xl sm:text-4xl font-bold text-white">Clienti e segnalatori collegati allo studio</h2>
      <div className="mt-14 grid lg:grid-cols-3 gap-6">
        {PORTALI.map(([Icon, title, items], i) => (
          <article key={title} className="rounded-2xl border border-white/10 bg-gradient-to-b from-white/[0.04] to-transparent p-8 hover:border-amber-500/40 transition-colors" data-testid={`landing-portal-${i}`}>
            <Icon className="h-8 w-8 text-amber-400" />
            <h3 className="mt-5 font-head text-xl font-semibold text-white">{title}</h3>
            <ul className="mt-5 space-y-3">
              {items.map((t) => <li key={t} className="flex gap-2.5 text-sm text-slate-300"><span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-amber-500" />{t}</li>)}
            </ul>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export const LandingSecurity = () => (
  <section id="sicurezza" className="py-24 sm:py-28 bg-[#0c1019] border-y border-white/5" data-testid="landing-security">
    <div className="mx-auto max-w-7xl px-5 sm:px-8 grid lg:grid-cols-[1fr_1.4fr] gap-12">
      <div>
        <span className="text-xs font-mono uppercase tracking-wider text-amber-400">Sicurezza</span>
        <h2 className="mt-3 font-head text-3xl sm:text-4xl font-bold text-white">I dati dei tuoi clienti, protetti</h2>
        <p className="mt-4 text-base md:text-lg text-slate-400">Un gestionale online accessibile ovunque, con controlli pensati per dati sensibili come quelli delle pratiche di sinistro.</p>
      </div>
      <div className="grid sm:grid-cols-2 gap-5">
        {SICUREZZA.map(([Icon, t, d], i) => (
          <div key={t} className="rounded-xl bg-white/[0.03] p-6" data-testid={`landing-security-${i}`}>
            <Icon className="h-5 w-5 text-amber-400" /><h3 className="mt-4 font-semibold text-white">{t}</h3><p className="mt-1.5 text-sm text-slate-400">{d}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export const LandingFooter = () => (
  <>
    <section className="py-24 sm:py-28" data-testid="landing-cta">
      <div className="mx-auto max-w-4xl px-5 sm:px-8 text-center">
        <h2 className="font-head text-3xl sm:text-4xl font-bold text-white">Il tuo studio, più organizzato da oggi</h2>
        <p className="mt-4 text-base md:text-lg text-slate-400">Sei già cliente PatroGestPro? Entra nel gestionale con le tue credenziali.</p>
        <Link to="/login" data-testid="landing-cta-login" className="mt-8 inline-flex items-center gap-2 rounded-full bg-amber-500 hover:bg-amber-400 px-7 py-3.5 text-sm font-semibold text-[#0a0d14] transition-colors">Accedi al Gestionale <ArrowRight className="h-4 w-4" /></Link>
      </div>
    </section>
    <footer className="border-t border-white/5 py-8" data-testid="landing-footer">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-500">
        <span className="flex items-center gap-2"><Shield className="h-4 w-4 text-amber-500" /> PatroGestPro · Software gestionale per l'infortunistica stradale</span>
        <span>© {new Date().getFullYear()} PatroGestPro · Servizi Globali</span>
      </div>
    </footer>
  </>
);
